import { useHandleEscapeKey } from 'hooks'
import { Box } from 'theme-ui'
import { DCProgressInput } from 'components/Form'
import { Heading } from 'components'
import { Label } from 'components/Form'
import { DCProgressProps } from 'types'

export const DCProgressModalV3 = ({
  name,
  set,
  cancel,
}: {
  name: string
  set: (lesson: DCProgressProps | undefined) => void
  cancel: () => void
}) => {
  useHandleEscapeKey(cancel)

  return (
    <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
      <Heading variant="forms.h1" sx={{ textAlign: 'left', mb: 20 }}>
        Adjust Digital Course position
      </Heading>
      <Label sx={{ fontWeight: 600 }}>Move student to:</Label>
      <Box>
        <DCProgressInput
          name={name}
          onChange={set}
          options={progressList}
          placeholder="Please select a module"
        />
      </Box>
    </div>
  )
}

// v3 session mapping: {1:1, 2:2, 3:2, 4:3, 5:3, 6:4}
// Each option targets the first lesson of that module.
const progressList: DCProgressProps[] = [
  { displayName: 'Module 2', lessonNumber: 2 },
  { displayName: 'Module 3', lessonNumber: 4 },
  { displayName: 'Module 4', lessonNumber: 6 },
  { displayName: 'Course Complete', lessonNumber: 7 },
]
